export const TEXT_COLORS = Object.freeze([
  "#1f2329",
  "#646a73",
  "#d83931",
  "#de7802",
  "#8f7c00",
  "#2b8a3e",
  "#245bdb",
  "#6425d0"
]);

export const BACKGROUND_COLORS = Object.freeze([
  "#f2f3f5",
  "#fde2e2",
  "#feead2",
  "#fff3bf",
  "#dff5df",
  "#d9f5f5",
  "#e0eaff",
  "#eee5ff"
]);

export const ALIGNMENTS = Object.freeze(["left", "center", "right"]);
export const MIN_INDENT = 0;
export const MAX_INDENT = 4;
const MAX_COLOR_PALETTE_SIZE = 64;

export function normalizeAlignment(value) {
  return typeof value === "string" && ALIGNMENTS.includes(value) ? value : null;
}

export function normalizeIndent(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return MIN_INDENT;
  return Math.min(MAX_INDENT, Math.max(MIN_INDENT, Math.trunc(value)));
}

export function normalizeColor(value, palette) {
  try {
    if (typeof value !== "string" || !Array.isArray(palette)) return null;
    const length = palette.length;
    if (!Number.isSafeInteger(length) || length < 0 || length > MAX_COLOR_PALETTE_SIZE) return null;
    const normalized = value.toLowerCase();
    for (let index = 0; index < length; index += 1) {
      const candidate = palette[index];
      if (typeof candidate === "string" && candidate.toLowerCase() === normalized) return candidate.toLowerCase();
    }
    return null;
  } catch {
    return null;
  }
}
